import clsx from "clsx";
import {
  Activity,
  Award,
  BadgeCheck,
  BarChart,
  Beaker,
  Bone,
  Book,
  BookOpen,
  BookText,
  Brain,
  BrainCircuit,
  Briefcase,
  Building,
  Calculator,
  Car,
  ChartColumn,
  ChevronUp,
  Circle,
  CheckCircle as CircleCheck,
  Clipboard,
  Clock,
  Code,
  Compass,
  Computer,
  Cross,
  Crown,
  Diamond,
  Divide,
  Dna,
  DollarSign,
  Earth,
  Eye,
  FileCog,
  FileStack,
  FileText,
  FileType2 as FileType,
  Flag,
  Flame,
  FlaskConical,
  FlaskRound,
  FunctionSquare as Function,
  Globe,
  GraduationCap,
  Hash,
  Heart,
  Home,
  Hourglass,
  Languages,
  Leaf,
  Lightbulb,
  Lock,
  LucideIcon,
  Medal,
  MessageSquare as Message,
  Microscope,
  Minus,
  Banknote as Money,
  Monitor,
  Notebook,
  Paintbrush,
  PenTool as Pen,
  Pencil,
  PersonStanding as Person,
  Pill,
  Flower2 as Plant,
  Plus,
  Presentation,
  Rocket,
  Ruler,
  Scale,
  School,
  Shield,
  Sigma,
  SquareActivity,
  Star,
  Stethoscope,
  Sun,
  Target,
  Telescope,
  TestTube,
  TreeDeciduous as Tree,
  TrendingUp,
  Triangle,
  Trophy,
  Type,
  User,
  UserCog,
  Users,
  Wallet,
  Wrench,
  X,
  Zap,
} from "lucide-react";
import { LucideProps } from "lucide-react";
import { Database } from "supabase/database.types";

export const ICON_MAP: Record<Database["public"]["Enums"]["icon"], LucideIcon> =
  {
    Activity,
    Award,
    BadgeCheck,
    BarChart,
    Beaker,
    Bone,
    Book,
    BookOpen,
    BookText,
    Brain,
    BrainCircuit,
    Briefcase,
    Building,
    Calculator,
    Car,
    ChartColumn,
    ChevronUp,
    Circle,
    CircleCheck,
    Clipboard,
    Clock,
    Code,
    Compass,
    Computer,
    Cross,
    Crown,
    Diamond,
    Divide,
    Dna,
    DollarSign,
    Earth,
    Eye,
    FileCog,
    FileStack,
    FileText,
    FileType,
    Flag,
    Flame,
    FlaskConical,
    FlaskRound,
    Function,
    Globe,
    GraduationCap,
    Hash,
    Heart,
    Home,
    Hourglass,
    Languages,
    Leaf,
    Lightbulb,
    Lock,
    Medal,
    Message,
    Microscope,
    Minus,
    Money,
    Monitor,
    Notebook,
    Paintbrush,
    Pen,
    Pencil,
    Person,
    Pill,
    Plant,
    Plus,
    Presentation,
    Rocket,
    Ruler,
    Scale,
    School,
    Shield,
    Sigma,
    SquareActivity,
    Star,
    Stethoscope,
    Sun,
    Target,
    Telescope,
    TestTube,
    Tree,
    TrendingUp,
    Triangle,
    Trophy,
    Type,
    User,
    UserCog,
    Users,
    Wallet,
    Wrench,
    X,
    Zap,
  };

export const ICON_COLOR_MAP: Record<
  Database["public"]["Enums"]["color"],
  string
> = {
  amber: "text-amber-600 dark:text-amber-400",
  blue: "text-blue-600 dark:text-blue-400",
  cyan: "text-cyan-600 dark:text-cyan-400",
  emerald: "text-emerald-600 dark:text-emerald-400",
  gray: "text-gray-600 dark:text-gray-400",
  green: "text-lime-600 dark:text-lime-400",
  indigo: "text-indigo-600 dark:text-indigo-400",
  orange: "text-orange-600 dark:text-orange-400",
  pink: "text-pink-600 dark:text-pink-400",
  purple: "text-purple-600 dark:text-purple-400",
  red: "text-red-600 dark:text-red-400",
  yellow: "text-yellow-600 dark:text-yellow-400",
};

export const getSubjectIconColor = (
  color: Database["public"]["Enums"]["color"]
) =>
  ICON_COLOR_MAP[color as keyof typeof ICON_COLOR_MAP] || ICON_COLOR_MAP.gray;

const Icon = ({
  color,
  icon,
  ...props
}: LucideProps & {
  color?: Database["public"]["Enums"]["color"];
  icon: Database["public"]["Enums"]["icon"];
}) => {
  const Icon = ICON_MAP[icon] ?? ICON_MAP.BookOpen;
  return (
    <Icon
      {...props}
      className={clsx(color && getSubjectIconColor(color), props.className)}
    />
  );
};

export default Icon;
